//angular imports
import { 
  ChangeDetectionStrategy,
  Component, 
  TemplateRef, 
  input 
} from '@angular/core';

//local imports
import { Transforms } from '@shared/helpers/transforms';
import { IListItem } from '@shared/components/list/model/list-item';


@Component({
    selector: 'item-small-generic',
    templateUrl: './item-small-generic.component.html',
    styleUrl: './item-small-generic.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ItemSmallGenericComponent {      
  public currentItem = input<IListItem>(null);
  public isSelectable = input(false, {
    transform: Transforms.toBoolean
  });
  
  public template? = input<TemplateRef<any>>(null);
}

